import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Edit from './editor.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/hm/management'

export default {
  name: 'hmManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: 'PERM_HM_MANAGERMENT',
    titleI18nKey: 'admin.company.hmManagement.title.hmManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.hmManagement.title.hmManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.hmManagement.title.hmManagement'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.hmManagement.title.hmAdd'
      }
    },
    {
      path: `${basePath}/edit/:companyHMId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        titleI18nKey: 'admin.company.hmManagement.title.hmEdit'
      }
    },
    {
      path: `${basePath}/password/:companyHMId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        isPasswordMode: true,
        titleI18nKey: 'admin.company.hmManagement.title.resetPassword'
      }
    }
  ]
}
